// Compliance.js
import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, Shield } from 'lucide-react';

const Compliance = () => {
  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Compliance and Transparency
          </h2>
        </motion.div>

        {/* Compliance Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Card 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <FileCheck size={24} className="text-blue-600" />
                </div>
              </div>
              <div>
                <h3 className="text-base font-semibold text-[#202356] mb-2">
                  Guidance Services Only
                </h3>
                <p className="text-sm text-gray-600 font-light leading-relaxed">
                  Notapaths provides guidance and application support services only. Admission and employment decisions are made solely by academic institutions and employers.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <Shield size={24} className="text-green-600" />
                </div>
              </div>
              <div>
                <h3 className="text-base font-semibold text-[#202356] mb-2">
                  Direct Financial Relationships
                </h3>
                <p className="text-sm text-gray-600 font-light leading-relaxed">
                  Tuition fees, employment contracts, salaries, and related payments are handled directly between candidates and the relevant institutions or employers. Notapaths does not collect tuition or salary payments on behalf of third parties.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
